export default function Privacy() {
  return (
    <div style={styles.page}>
      <h1>Privacy Policy</h1>

      <p>
        FentaSafe respects your privacy. This platform is designed for
        demonstration and informational purposes only.
      </p>

      <h3>Information Collection</h3>
      <p>
        FentaSafe does not collect personal data from users accessing the public
        website. Demo access may require OTP verification for controlled access.
      </p>

      <h3>Use of Information</h3>
      <p>
        Any data generated within the demo environment is simulated and used
        solely for demonstration and testing purposes.
      </p>

      <h3>Security</h3>
      <p>
        Reasonable technical measures are applied to prevent unauthorized access
        to demo systems.
      </p>

      <p style={styles.note}>
        This privacy policy applies only to the FentaSafe demonstration platform.
      </p>
    </div>
  );
}

const styles = {
  page: {
    padding: "40px",
    maxWidth: "900px",
    color: "#0f172a",
    background: "#ffffff",
  },
  note: {
    marginTop: 20,
    fontSize: 14,
    color: "#64748b",
  },
};
